import http, {
} from '../axios'
import getDomainName from './conf'

const {
  baseUrl,
} = getDomainName();

// http://gitlab.5fun.com/sdk/cwh_wechat  接口文档


/**
 * register
 * @param params username
 * @param params password
 * @returns {*}
 */
export function register(params) {
  return http('post', baseUrl + '/register', params,'json')
}

/**
 * 登录
 * @param params name 用户名
 * @param params pwd 密码
 * @returns {*}
 */
export function login(params) {
  return http('post', baseUrl + '/login', params,'json')
}


/**
 * 退出登录
 * @returns {*}
 */
export function logout(params) {
  return http('post', baseUrl + `/exitLogin`, {tokenId:params},'json')
}

/**
 * 获取个人通知
 * @param params name 用户名
 * @param params pwd 密码
 * @returns {*}
 */
export function noticeP() {
  return http('get', baseUrl + '/system/notice/getSelfInfo',)
}

/**
 * 获取二维码和支付地址
 * @returns {*}
 */
export function getPay() {
  return http('get', baseUrl + '/system/setting/getForApp',)
}

/**
 * 获取个人信息
 * @param params name 用户名
 * @param params pwd 密码
 * @returns {*}
 */
export function getPerson() {
  return http('get', baseUrl + '/system/user/profile',)
}

/**
 * 获取评论
 * @returns {*}
 */
export function getComments() {
  return http('get', baseUrl + '/system/comments/listAndOrder',)
}

/**
 * 获取商品信息
 * @returns {*}
 */
export function getGoods(kaType) {
  return http('get', baseUrl + '/system/goods/listByType?kaType=' + kaType,)
}

/**
 * 获取usdt
 * @returns {*}
 */
export function getUSDT() {
  return http('get', baseUrl + '/system/goods/getUSDT',)
}

/**
 * 下单
 * @returns {*}
 */
export function createOrder(id) {
  return http('get', baseUrl + '/system/order/create-transaction?id=' + id,)
}

/**
 * 获取ip信息
 * @returns {*}
 */
export function getIpInfo() {
  return http('get', baseUrl + '/system/user/profile/getIpInfo',)
}

export function getHelps() {
  return http('get', baseUrl + '/system/help/listAll',)
}

export function getCenterUser() {
  return http('get', baseUrl + '/system/user/center',)
}

export function listCenterOrder(status) {
  return http('get', baseUrl + '/system/order/center?orderStatus=' + status,)
}

export function getInfoByOrderId(id) {
  return http('get', baseUrl + '/system/notice/getInfoByOrderId?orderId=' + id)
}



// WEBPACK FOOTER //
// ./src/api/index.js